module.exports = __webpack_public_path__ + "img/psd1.848199eb.png";